<template>
  <div>
    <b-button v-b-modal.modalCreateGroup variant="primary">Create Chat</b-button>
    <b-modal id="modalCreateGroup" ref="modalCreateGroup" title="Select users" hide-footer>
      <b-alert v-if="mensagem" show variant="danger">{{ mensagem }}</b-alert>
      <b-form ref="form" @submit.prevent="salvar" v-if="show">
        <b-form-group
          v-if="usuariosSelecionados && usuariosSelecionados.length >1"
          id="example-input-group-1"
          label="Name"
          label-for="example-input-1"
        >
          <b-input
            name="groupName"
            type="text"
            v-model="nomeGrupo"
            placeholder="Group name"
            v-validate="{ required: true }"
            :state="validateState('groupName')"
            aria-describedby="input-1-live-feedback"
          ></b-input>
          <b-form-invalid-feedback id="input-1-live-feedback">Group name is a required field.</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="example-input-group-2">
          <b-alert
            variant="danger"
            v-if="!usuariosSelecionados || usuariosSelecionados.length <=0"
            show
          >Select at least one user to create.</b-alert>
          <ListarUsuariosGrupos v-model="usuariosSelecionados" />
        </b-form-group>
        <b-row align-h="between">
          <b-col :sm="12" :md="6">
            <b-btn variant="secondary" size="lg" block @click="cancel">Cancel</b-btn>
          </b-col>
          <b-col :sm="12" :md="6">
            <b-btn type="submit" variant="success" size="lg" block :disabled="loading">
              <b-spinner v-if="loading" variant="light"></b-spinner>
              <span v-else>Create</span>
            </b-btn>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ListarUsuariosGrupos from './ListarUsuariosGrupos.vue';

export default {
  components: {
    ListarUsuariosGrupos,
  },
  data() {
    return {
      usuariosSelecionados: undefined,
      nomeGrupo: undefined,
      show: true,
      loading: false,
      mensagem: undefined,
    };
  },
  computed: {
    ...mapGetters(['usuarioLogado']),
  },
  methods: {
    ...mapActions(['salvarGrupo']),
    async salvar() {
      try {
        this.loading = true;
        this.mensagem = undefined;
        if (this.usuariosSelecionados.length > 1) {
          const valid = await this.$validator.validateAll();
          if (!valid) {
            return;
          }
          await this.criarGrupo();
        } else {
          await this.criarChat();
        }
      } catch (error) {
        console.log(error);
        this.mensagem = error.message;
        const index = this.usuariosSelecionados.findIndex(
          (u) => u.id == this.usuarioLogado,
        );
        if (index >= 0) this.usuariosSelecionados.splice(index, 1);
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.nomeGrupo = undefined;
      this.usuariosSelecionados = undefined;
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    cancel() {
      this.reset();
      this.$refs.modalCreateGroup.hide();
    },
    validateState(ref) {
      if (
        this.veeFields[ref]
        && (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    async criarGrupo() {
      if (this.usuariosSelecionados && this.usuariosSelecionados.length > 0) {
        this.usuariosSelecionados.push(this.usuarioLogado);
        await this.salvarGrupo({
          nomeGrupo: this.nomeGrupo,
          usuarios: this.usuariosSelecionados,
        });
        this.reset();
        this.$refs.modalCreateGroup.hide();
      }
    },
    async criarChat() {
      if (this.usuariosSelecionados && this.usuariosSelecionados.length == 1) {
        this.usuariosSelecionados.push(this.usuarioLogado);
        await this.salvarGrupo({
          usuarios: this.usuariosSelecionados,
        });
        this.reset();
        this.$refs.modalCreateGroup.hide();
      }
    },
  },
};
</script>

<style>
</style>
